import * as React from 'react';
import UserInfo from './UserInfo';
import { Button, Col, Row } from 'antd';
import style from './UserInfo.module.scss';
import { observer } from 'mobx-react';
import PageLoader from 'common/components/PageLoader';
import UserData from 'web/screen/HomePage/UserInfo/UserData';
import UserAddressesView from 'common/components/UserAddresses/UserAddressesView';
import MembershipData from 'web/screen/HomePage/UserInfo/MembershipData';
import { useTranslation } from 'react-i18next';
import CompetitionsListView from 'web/components/CompetitionsList/CompetitionsListView';
import ArrowPanel from 'web/components/ArrowPanel';
import DeleteAccountDialog from './DeleteAccountDialog/DeleteAccountDialog';
import DeleteAccountDialogView from 'web/screen/HomePage/UserInfo/DeleteAccountDialog/DeleteAccountDialogView';
import Plus from 'common/icons/plus.svg';
import Link from 'web/components/Link';
import Flex from 'common/components/Flex';
import BecomeMemberPanel from 'web/components/BecomeMemberPanel';
interface UserInfoViewProps {
    model: UserInfo;
}

const UserInfoView: React.FC<UserInfoViewProps> = observer(({ model }) => {
    const { t } = useTranslation(['homePage', 'common', 'subMenu']);

    return (
        <PageLoader loader={model.api}>
            <Row gutter={[20, 40]}>
                <Col xs={24} lg={8}>
                    <div className={style.box}>
                        <UserData model={model} />
                        <hr />
                        <div className={style.container}>
                            <Flex
                                justifyContent='space-between'
                                alignItems='center'>
                                <span className={style.invoice}>
                                    {t('homePage:invoiceAddresses')}:
                                </span>
                                <div className={style.actions}>
                                    <>
                                        <img
                                            src={Plus}
                                            alt={t('userAddresses:addAddress')}
                                            className={style.dropdownIcon}
                                        />

                                        <Link
                                            onClick={() =>
                                                model.userAddress.onCreateAddress()
                                            }
                                            style={style.add}>
                                            {t('userAddresses:addAddress')}
                                        </Link>
                                    </>
                                </div>
                            </Flex>
                            <UserAddressesView model={model.userAddress} />
                            <hr />
                            <Button
                                type={'text'}
                                size={'small'}
                                onClick={model.showDeleteAccountModal}
                                className={style.deleteAccount}>
                                {t('homePage:deleteAccountTitle')}
                            </Button>
                        </div>
                    </div>
                    {model.parent.userDto.isJudge && (
                        <ArrowPanel
                            contentBox={
                                <span className={style.judgeBtnTxt}>
                                    {t('subMenu:judge')}
                                </span>
                            }
                            onClick={() => model.parent.showJudgePage()}
                            containerStyle={style.judgeBtn}
                        />
                    )}
                </Col>
                <Col xs={24} lg={16}>
                    {model.parent.userDto.isMember !== undefined && (
                        <>
                            {model.parent.userDto.isMember ||
                            model.parent.userDto.hasPendingApplication ? (
                                <div className={style.membershipBox}>
                                    <MembershipData model={model} />
                                </div>
                            ) : (
                                <div className={style.become}>
                                    <BecomeMemberPanel
                                        title={t('homePage:becomeMember')}
                                        desc={t('homePage:createMembership')}
                                        onClick={
                                            model.parent
                                                .showMembershipApplication
                                        }
                                    />
                                </div>
                            )}

                            <CompetitionsListView
                                model={
                                    model.parent.competitionList.competitions
                                }
                                onDetails={
                                    model.parent.showSelectedCompetitions
                                }
                            />
                        </>
                    )}
                </Col>
            </Row>
            {model.parent.dialog instanceof DeleteAccountDialog && (
                <DeleteAccountDialogView dialog={model.parent.dialog} />
            )}
        </PageLoader>
    );
});

export default UserInfoView;
